import Glide from '@glidejs/glide'

export default function videoSlider (){
// VIDEO SLIDER
  const contentSlider = document.querySelector('.glideContent')
  const videoSlider = document.querySelector('.glideVideo')

  let content = new Glide(contentSlider)
  let video = new Glide(videoSlider,{
    gap: 0,
    keyboard: false
  })

  content.on("run", function() {
    video.go(`=${content.index}`)
  })

  content.mount();
  video.mount();
}
